import React from 'react';
import { getPayoutOptions } from '@monorepo/client-types';
import { Flex } from '@monorepo/react-components';
import { useResponsiveness } from '@monorepo/react-hooks';
import {
  useCryptoWithdrawalLimit,
  usePayoutForm,
  usePayoutSubmission,
} from './hooks';
import { PayoutRequestFormProps } from './types';
import { getPaymentForm } from './utils';
import {
  FormActions,
  NotesAndTermsSection,
  PaymentMethodsSection,
  PayoutHeader,
  WithdrawalAmountSection,
} from './withdraw-components';

export const PayoutRequestForm: React.FC<PayoutRequestFormProps> = (props) => {
  const {
    maxWithdrawal,
    showAmountSelection,
    source,
    sourceId,
    displayName,
    modalRef,
    validateWithDrawEligible,
    credits,
    userPayoutPercentage,
  } = props;

  const { isMobile } = useResponsiveness();

  // Form state and validation
  const {
    form,
    selectedPaymentOption,
    whatUserGets,
    handleMinimumValidation,
    isSubmitDisabled,
  } = usePayoutForm({
    maxWithdrawal,
    credits,
    userPayoutPercentage,
    source,
  });

  // Crypto-specific logic and limits
  const { maxWithdrawalLimit, maximumWithdrawalMessage } =
    useCryptoWithdrawalLimit({
      maxWithdrawal,
      selectedPaymentOption,
    });

  // Form submission and API handling
  const { beneficiaryFormRef, isLoading, handleSubmit, handleCancel } =
    usePayoutSubmission({
      source,
      sourceId,
      maxWithdrawal,
      showAmountSelection,
      validateWithDrawEligible,
      modalRef,
      form,
    });
  return (
    <Flex
      vertical
      align="center"
      gap={isMobile ? 12 : 32}
      className="withdraw-funds"
    >
      <Flex vertical align="center" gap={10}>
        <PayoutHeader
          source={source}
          displayName={displayName}
          maxWithdrawal={maxWithdrawal}
        />

        {showAmountSelection && (
          <WithdrawalAmountSection
            form={form}
            maxWithdrawalLimit={maxWithdrawalLimit}
            whatUserGets={whatUserGets}
            maximumWithdrawalMessage={maximumWithdrawalMessage}
            handleMinimumValidation={handleMinimumValidation}
          />
        )}

        <PaymentMethodsSection
          form={form}
          selectedPaymentOption={selectedPaymentOption}
          payoutOptions={getPayoutOptions()}
        />

        {getPaymentForm(selectedPaymentOption, form, beneficiaryFormRef)}

        <NotesAndTermsSection source={source} form={form} />
      </Flex>

      <FormActions
        isLoading={isLoading}
        isDisabled={isSubmitDisabled}
        onCancel={handleCancel}
        onSubmit={handleSubmit}
      />
    </Flex>
  );
};
